import Header from "../navigation/headerContainer";
import PlaceBidWithPropertyDetail from "./placeBidContainer";
import Footer from "../navigation/footerContainer";


export default function PropertyPage(){
    return(
        <>
            <Header />
            <PlaceBidWithPropertyDetail />
            <Footer />
        </>
    )
}